<template>
  <b-card no-body class="shadow flex-container grid-stack-item-content flow-window">
    <div slot="header">
      <window-header cmp-title="Production Report" widget-name="westside_production">
        <template slot="options">

        </template>
      </window-header>
    </div>

    <div :style="{'flex': 2, 'overflow': 'hidden'}" class="position-relative p-2">
      <div class="row h-100">
        <div class="col-9">
          <div ref="renderArea" class=" h-100" :style="{'flex': 2, 'overflow': 'hidden', 'position': 'relative'}">
            <svg ref="svg" class="h-100 w-100"></svg>
          </div>
        </div>
        <div class="col-3 h-100" :style="{ 'overflow': 'auto'}">
          <b-form-group label="Fields">
            <b-form-checkbox
              @change="aggData($event, 'all')"
              v-model="allFields"
              :value="true"
              :unchecked-value="false"
            >
             all
            </b-form-checkbox>

            <b-form-checkbox-group
              @change="aggData($event, 'fields')"
              v-model="fieldsSel"
              :options="fields"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>

          <b-form-group label="Attributes" class="mt-1">

            <b-form-select @input="aggData" v-model="selectedMode" :options="modes"></b-form-select>
            <div class="ml-2" v-show="selectedMode==='finance'">
              <template  v-for="(v, i) in attrs">
                <b-form-checkbox
                  @change="aggData($event, 'attrs')"
                  :key="v.value"
                  v-model="attrsSel[i]"
                  :value="v.value"
                  :unchecked-value="'_'+v.value"
                  stacked
                >{{v.text}}<div class="color-ind" :style="{'background-color': v.color}"></div></b-form-checkbox>
              </template>

            </div>


          </b-form-group>

        </div>
      </div>
      <loading-overlay :show="loading"></loading-overlay>
    </div>


  </b-card>
</template>

<script>

  import WindowHeader from '../common/WindowHeader'
  import LoadingOverlay from '../LoadingOverlay'
  import { select } from 'd3-selection'

  import { axisBottom, axisLeft } from 'd3-axis'
  import { scaleLinear, schemeCategory10, scaleOrdinal } from 'd3-scale'
  import { extent, range } from 'd3-array'
  import { line as d3Line } from 'd3-shape'

  export default {
    name: 'ProductionReport',
    components: {LoadingOverlay, WindowHeader},
    data () {
      return {
        loading: false,
        allFields: true,
        fields: [],
        fieldsSel: [],
        attrs: [
          {
            "value": 'revenue',
            "text": 'Revenue',
            "checked": true,
            "color": '#000000'
          },
          {
            "value": 'trunkline_cost',
            "text": 'Trunkline cost',
            "checked": true,
            "color": '#000000'
          },
          {
            "value": 'connection_cost',
            "text": 'Connection cost',
            "checked": true,
            "color": '#000000'
          }
        ],
        attrsSel: [],
        selectedMode: 'finance',
        modes: [
          { value: 'finance', text: 'Finances' },
          { value: 'water', text: 'Water amount' },
          { value: 'gas', text: 'Gas amount' },
          ]
      }
    },
    created () {
      this.data = []
      this.pack = []
    },
    mounted () {
      this.loadData()
    },
    computed: {
      resizeMap () {
        return this.$store.getters['map/widgetResizeMap']['westside_production']
      }
    },
    watch: {
      resizeMap () {
        console.log('resize map')
        this.renderChart(this.pack)
      }
    },
    methods: {
      defineFilters() {
        let k = {}
        let ka = {}
        this.data.forEach(d => {
          k[d['gas_dest']] = true
          ka[d['name']] = true
        })
        Object.keys(k).forEach(key => this.fields.push(key))
        // Object.keys(ka).forEach(key => this.attrs.push(key))

        this.attrs.forEach(a => this.attrsSel.push(a.value))

        this.aggData()
      },
      aggData(val, mode) {

        let allFields = this.allFields
        let selFields = this.fieldsSel
        let selAttrs = [...this.attrsSel]

        if (mode === 'all' && val) {
          this.fieldsSel.splice(0, this.fieldsSel.length)
          allFields = true
        }

        if (mode === 'fields' && val.length) {
          this.allFields = allFields = false
          selFields = [...val]
        }


        if (mode === 'attrs') {

          if (val[0] === '_') {
            let i = selAttrs.indexOf(val.slice(1))
            selAttrs.splice(i, 1)
          } else {
            selAttrs.push(val)
          }
        }

        selAttrs=selAttrs.filter(a => a[0] !== '_')

        let data = {}

        let years = this.data.map(d => d['year'])
        let ky = {}
        years.forEach(y => ky[y] = true)
        years = Object.keys(ky).sort((y1, y2) => y1-y2).map(y => parseInt(y)).slice(0, 50)

        data['years'] = years
        data['data'] = {}

        let attrs = []

        if (this.selectedMode === 'finance') {
          attrs = [...selAttrs]
        } else if (this.selectedMode === 'gas') {
          attrs = ['gas_amount']
        } else if (this.selectedMode === 'water') {
          attrs = ['water_amount']
        }

        let ranges = []

        attrs.forEach(a => {
          let fd = this.data.filter(d => allFields || selFields.indexOf(d['gas_dest']) > -1)

          let values = []
          years.forEach(y => {
            values.push(fd.filter(d => d['year'] === y && d['name'] === a).map(d => parseFloat(d['value'])).reduce((a, c) => a+c,0))
          })

          ranges = ranges.concat(extent(values))

          data['data'][a] = {
            values: values
          }

        })

        data['extent'] = extent(ranges)

        this.pack = data

        this.renderChart(data)


      },
      renderChart(pack) {
        let svg = select(this.$refs.svg)
        svg.selectAll('*').remove()
        let bbox = this.$refs.svg.getBoundingClientRect()
        let paddingLeft = 80
        let paddingRight = 10
        let paddingBottom = 80
        let paddingTop = 10
        let width = bbox.width - paddingLeft - paddingRight
        let height = bbox.height - paddingBottom - paddingTop

        let scaleX = scaleOrdinal().domain(pack.years).range(range(0, width, width/pack.years.length))

        svg.append('g')
          .attr('transform', 'translate(' + paddingLeft + ',' + (bbox.height - paddingBottom) + ')')
          .call(axisBottom().scale(scaleX)
            /*.tickFormat((d, i) => pack.years[i])*/)
          .selectAll("text")
          .attr("y", 0)
          .attr("x", 9)
          .attr("dy", ".35em")
          .attr("transform", "rotate(90)")
          .style("text-anchor", "start")

        let scaleY = scaleLinear().domain(pack.extent).range([height, 0])
        svg.append('g')
          .attr('transform', 'translate(' + paddingLeft + ','+paddingTop+')')
          .call(axisLeft().scale(scaleY)
            .tickValues([pack.extent[0], (pack.extent[0] + pack.extent[1]) / 2, pack.extent[1]]))

        let line = d3Line()
          .x(function (d, i) { return scaleX(pack.years[i]) })
          .y(function (d) { return scaleY(d) })

        let c = scaleOrdinal(schemeCategory10)

        Object.keys(pack.data).forEach((key, i) => {
          let data = pack.data[key].values
          svg.append('g')
            .attr('transform', 'translate(' + paddingLeft + ', '+paddingTop+')')
            .datum(data)
            .append('path')
            .attr('class', 'metrics-line')
            .attr('stroke', c(i))
            .attr('d', line)

          this.attrs.filter(a => a.value === key)[0].color = c(i)
        })



      },
      loadData () {
        this.loading = true
        this.$http.get("/api/projects/load-westside-data", {
          params: {
            workpack_id: this.$store.getters['project/currentProject'].workpack.id
          }
        }).then(res => {
          this.loading = false
          this.data = res.body
          this.defineFilters()
        }, e => {
          this.loading = false
          this.$notify({
            title: 'ERROR',
            text: 'Could not load data',
            type: 'error'
          })
        })
      }
    }
  }
</script>

<style lang="scss">
  .metrics-line {
    fill: none;
    stroke-width: 2px;
  }

  .color-ind {
    width: 1rem;
    height: 1rem;
    float: left;
    margin-right: 0.5rem;
    margin-top: 0.2rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/westside/ProductionReport.vue